
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  CreatePublicDraftInstantConversationRequest,
} from '../models';
import {
    CreatePublicDraftInstantConversationRequestFromJSON,
    CreatePublicDraftInstantConversationRequestToJSON,
} from '../models';

export interface CreatePublicDraftInstantConversationOperationRequest {
    createPublicDraftInstantConversationRequest: CreatePublicDraftInstantConversationRequest;
}

/**
 * 
 */
export class PublicInstantConversationApi extends runtime.BaseAPI {

    /**
     * Create a draft instant conversation between a freelancer and an unlogged user 
     * Create a draft instant conversation between a freelancer and an unlogged user
          */
    async createPublicDraftInstantConversationRaw(requestParameters: CreatePublicDraftInstantConversationOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<string>> {
        if (requestParameters['createPublicDraftInstantConversationRequest'] == null) {
            throw new runtime.RequiredError(
                'createPublicDraftInstantConversationRequest',
                'Required parameter "createPublicDraftInstantConversationRequest" was null or undefined when calling createPublicDraftInstantConversation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<string>({
            path: `/profile/public-api/conversation/instant/draft`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePublicDraftInstantConversationRequestToJSON(requestParameters['createPublicDraftInstantConversationRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Create a draft instant conversation between a freelancer and an unlogged user 
     * Create a draft instant conversation between a freelancer and an unlogged user
          */
    async createPublicDraftInstantConversation(requestParameters: CreatePublicDraftInstantConversationOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.createPublicDraftInstantConversationRaw(requestParameters, initOverrides);
        return response._data;
    }

}
